import React, { useEffect, useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Select, Space, Spin } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { Add, Delete, OpenInFull, Refresh, SwipeUp } from '@mui/icons-material';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import { FormProvider, useForm } from 'react-hook-form';
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchInput from '../../../SearchInput';
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ShowFile from '../../../ShowFile';
import Relation from '../../../../Models/Relation';
import RELATION from '../../../../Models/Relation';
import Billetage from '../../../Billetage';
import InputForm from '../../../InputT';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';

interface SelectData {
  value: string,
  label: string,
}

function Tab3(props: { form?: any }) {
  
  // function getToatal() {
  //   props.form.setFieldValue('TotalBilletage', 
  //   formatNumber(
  //     parseInt((props.form.getFieldValue("NOMB01")? props.form.getFieldValue("NOMB01") : 0))*10000+
  //     parseInt((props.form.getFieldValue("NOMB02")? props.form.getFieldValue("NOMB02") : 0))*5000+
  //     parseInt((props.form.getFieldValue("NOMB03")? props.form.getFieldValue("NOMB03") : 0))*2000+
  //     parseInt((props.form.getFieldValue("NOMB04")? props.form.getFieldValue("NOMB04") : 0))*1000+
  //     parseInt((props.form.getFieldValue("NOMB05")? props.form.getFieldValue("NOMB05") : 0))*500+
  //     parseInt((props.form.getFieldValue("NOMB06")? props.form.getFieldValue("NOMB06") : 0))*500+
  //     parseInt((props.form.getFieldValue("NOMB07")? props.form.getFieldValue("NOMB07") : 0))*100+
  //     parseInt((props.form.getFieldValue("NOMB08")? props.form.getFieldValue("NOMB08") : 0))*50+
  //     parseInt((props.form.getFieldValue("NOMB09")? props.form.getFieldValue("NOMB09") : 0))*25+
  //     parseInt((props.form.getFieldValue("NOMB10")? props.form.getFieldValue("NOMB10") : 0))*10+
  //     parseInt((props.form.getFieldValue("NOMB11")? props.form.getFieldValue("NOMB11") : 0))*5+
  //     parseInt((props.form.getFieldValue("NOMB12")? props.form.getFieldValue("NOMB12") : 0))*2+
  //     parseInt((props.form.getFieldValue("NOMB13")? props.form.getFieldValue("NOMB13") : 0))*1)
  //   )
  // }
  // useEffect(()=>{
  //   getToatal()
  // })
  
  return (

    <div className='tabItem'>
    <Box width={"88%"}>
      <Billetage withTatal form={props.form} />
    </Box>
  </div>
  );
}

export default Tab3;